import { createApp } from 'vue'
import App from './App.vue'

import router from './router'
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faGraduationCap,
  faPaperPlane,
  faCode
} from '@fortawesome/free-solid-svg-icons';
import { faGithub, faLinkedin, faFortAwesome, faThemeco, faWeixin } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
  faGraduationCap,
  faPaperPlane,
  faCode,
  faGithub,
  faLinkedin,
  faFortAwesome,
  faThemeco,
  faWeixin
);
createApp(App).use(router).component('font-awesome-icon', FontAwesomeIcon).mount('#app')
